module.exports = __webpack_public_path__ + "static/C2016_IEEE_abs-fe921262fba21f66ff01279b525c1b00.jpg";